export default __webpack_public_path__ + "images/fc81f0f60ea032f78e111e44c4f1c7c7-cc-mini-front@2x.png";